import { useState } from 'react';

const faqs = [
  {
    q: '91叔叔是什么平台？',
    a: '91叔叔是一个综合性的内容聚合与分享平台，致力于为用户提供优质文章、实用资源、使用指南和最新资讯。平台通过分类浏览、智能推荐等方式，帮助用户高效获取有价值的信息。',
  },
  {
    q: '如何注册91叔叔账号？',
    a: '注册91叔叔账号非常简单：访问官方首页，点击右上角的"注册"按钮，填写邮箱地址并设置密码即可完成注册。整个过程只需1-2分钟，注册后即可畅享平台全部基础功能。',
  },
  {
    q: '91叔叔会员有哪些权益？',
    a: '91叔叔会员享有以下专属权益：无广告纯净浏览体验、优先访问最新内容（提前24小时）、会员专属优质资源库、高速下载通道（速度提升3倍）、跨设备收藏与历史同步、专属客服通道等。',
  },
  {
    q: '91叔叔的内容多久更新一次？',
    a: '91叔叔平台的内容保持高频更新：每日有新的文章和资源发布，每周进行内容精选推荐，每月推出专题合集和会员专属内容。用户可以通过关注分类或设置内容提醒，第一时间获取更新通知。',
  },
  {
    q: '如何找到91叔叔的最新官方入口？',
    a: '建议将91叔叔官方首页加入浏览器收藏夹。同时可以关注我们的官方社交媒体账号获取最新动态。如果遇到访问问题，可以通过官方客服邮箱联系获取最新入口信息。',
  },
  {
    q: '91叔叔平台是否安全？',
    a: '91叔叔高度重视用户安全与隐私保护。平台采用先进的加密技术保护用户数据，支持双重验证功能，并提供完善的隐私设置选项。我们建议用户设置强密码并开启双重验证以增强账号安全性。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a,
      },
    })),
  };

  return (
    <section className="w-full px-4 md:px-6 py-16 bg-background-50">
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            常见问题
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base">
            关于91叔叔的常见疑问，这里都有答案
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="border border-background-200/70 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => toggle(idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-background-100/70 transition-colors"
              >
                <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {faq.q}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-lg text-foreground-400 transition-transform duration-300 shrink-0 ${
                    openIndex === idx ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === idx && (
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}